import { useParams, useSearchParams } from "react-router";
import { useEffect, useState } from "react";

export const useCustomParam = (): (key: string) => string | null => {
  const pathParams = useParams();
  const [searchParams] = useSearchParams();

  const getParam = (key: string): string | null => {
    if (pathParams[key] && pathParams[key] != undefined) {
      return decodeURIComponent(pathParams[key] as string);
    }
  
    const param = searchParams.get(key);
    if (param) return decodeURIComponent(param);
  
    return null;
  };

  return getParam;
};



export const useTheme = () => {
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    if (typeof window !== "undefined" && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    
    return "light";
  });

  useEffect(() => {
    // Update HTML class when theme changes
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
  }, [theme]);

  useEffect(() => {
    // Listen for system preference changes (only if no manual preference is set)
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e: MediaQueryListEvent) => {
        setTheme(e.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return { theme, setTheme };
};